import { PropsWithChildren, ReactElement } from "react";

export const StepWrapper: React.FC<PropsWithChildren<{}>> = ({ children }) => (
  <div className="flex flex-col gap-4 max-w-4xl items-center justify-center tab:py-6">
    {children}
  </div>
);

export const StepContent: React.FC<
  PropsWithChildren<{
    title: string | ReactElement;
    description?: string | ReactElement;
  }>
> = ({ title, children, description }) => (
  <div
    className="flex flex-col justify-center items-center text-center gap-6"
    suppressHydrationWarning>
    <h3 className="subhead1">{title}</h3>
    <p className="body1 text-coinage-body">{description}</p>
    {children}
  </div>
);
